
  import * as Sentry from '@sentry/browser';

  Sentry.init({ dsn: 'https://7569251f7e8c46ad8c6d6a3281a0b4fd@o589494.ingest.sentry.io/6048248' });

  window.Sentry = Sentry;

